<template>
  <v-row justify="center">
    <div class="mt-2 w-100">
      <v-alert
        v-model="dialog"
        dismissible
        color="switchq"
        elevation="6"
        colored-border
        border="top"
      >
        <span v-if="title">
          {{ title }}
          <br />
        </span>
        {{ message }}
        <template v-if="ad.dispatch.advertisement" v-slot:prepend>
          <div class="logoCont">
            <img ref="logoImage" :src="src" class="transparent mx-auto" />
          </div>
        </template>
        <template v-if="ad.dispatch.advertisement" v-slot:close>
          <v-icon
            v-if="
              !ad.dispatch.advertisement.must_agree ||
              ad.dispatch.advertisement.must_agree == 0
            "
            color="red"
            :size="20"
            @click="
              type == 'whatsappLeft' || type == 'smsLeft'
                ? close()
                : closeNotification()
            "
          >
            mdi-close
          </v-icon>
        </template>
        <template v-if="ad.dispatch.advertisement" v-slot:append>
          <span
            v-if="
              ad.dispatch.advertisement.must_agree &&
              ad.dispatch.advertisement.must_agree != 0
            "
          >
            <v-btn
              text
              color="switchq"
              @click="
                type == 'whatsappLeft' || type == 'smsLeft'
                  ? close()
                  : closeNotification()
              "
              >{{ $t("confirm") }}</v-btn
            >
            <v-btn
              text
              v-if="
                type != 'advertisement' &&
                type != 'smsLeft' &&
                type != 'whatsappLeft' &&
                ad.dispatch.advertisement.allow_disagree == 1
              "
              color="red"
              @click="disNotification"
              >{{ $t("decline") }}</v-btn
            >
            <v-btn
              text
              color=""
              v-if="ad.dispatch.advertisement.must_agree == 2"
              @click="dissmissAd"
              >{{ $t("cancel-for-now") }}</v-btn
            >
          </span>
        </template>
      </v-alert>
    </div>
  </v-row>
</template>
<script>
import auth from "@/helpers/auth";
export default {
  name: "AdvertisementBanner",
  props: {
    activator: {
      type: Boolean,
      default: false,
    },
    ad: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    src() {
      const url = process.env.VUE_APP_ASSETS + "logo.png?token=";
      return url + auth.getToken();
    },
    dialog() {
      // get() {
      return this.activator;
      // },
      // set(value) {
      //   this.$emit("closeDialog", value);
      //   // this.activator = false;
      // },
    },
    title() {
      return this.ad.dispatch.advertisement
        ? this.ad.dispatch.advertisement.title
        : "";
    },
    message() {
      return this.ad.dispatch.advertisement
        ? this.ad.dispatch.advertisement.message
        : "";
    },
    slug() {
      return this.ad.dispatch.advertisement.slug;
    },
  },
  created() {
    // this.dialog = this.activator;
    // console.log("this.ad", this.ad);
  },
  mounted() {
    // setTimeout(async () => {
    //   if (
    //     (this.dialog && this.ad.dispatch.advertisement.must_agree == 0) ||
    //     (this.dialog && !this.ad.dispatch.advertisement.must_agree)
    //   ) {
    //     if (this.type == "advertisement") {
    //       await this.$store.dispatch(
    //         "notificationAdvertisements/setWatched",
    //         this.slug
    //       );
    //     }
    //     if (this.type == "system") {
    //       await this.$store.dispatch(
    //         "systemAdvertisements/setWatched",
    //         this.slug
    //       );
    //     }
    //   }
    // }, 10000);
  },
  methods: {
    close() {
      this.$emit("closeDial", false);
    },
    async closeNotification() {
      // console.log("closeNotification");
      if (this.ad.watched_at == null || this.ad.watched_at == "") {
        if (this.type == "advertisement") {
          await this.$store.dispatch(
            "notificationAdvertisements/setWatched",
            this.slug
          );
        }
        if (this.type == "system") {
          await this.$store.dispatch(
            "systemAdvertisements/setWatched",
            this.slug
          );
        }
      }
      // this.dissmissAd();
      // this.dialog = false;
    },
    async disNotification() {
      // if (this.ad.watched_at == null || this.ad.watched_at == "") {
      // if (this.type == "advertisement") {
      //   await this.$store.dispatch(
      //     "notificationAdvertisements/setDisWatched",
      //     this.slug
      //   );
      // }
      if (this.type == "system") {
        await this.$store.dispatch(
          "systemAdvertisements/setDisWatched",
          this.slug
        );
      }
      // }
      this.dissmissAd();
      // this.dialog = false;
    },
    async dissmissAd() {
      // if (this.ad.watched_at == null || this.ad.watched_at == "") {
      if (this.type == "advertisement") {
        await this.$store.dispatch(
          "notificationAdvertisements/dissmiss",
          this.slug
        );
      }
      if (this.type == "system") {
        await this.$store.dispatch("systemAdvertisements/dissmiss", this.slug);
      }
      // }
      // this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.logoCont {
  display: flex;
  padding: 8px 16px;
  img {
    max-width: 40px;
    height: auto;
  }
}
</style>
